import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No groups found", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { width: "30%" }, "Name"),
  /*#__PURE__*/_createElementVNode("th", { width: "10%" }, "Precedance"),
  /*#__PURE__*/_createElementVNode("th", { width: "60%" }, "Discription")
], -1)

import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'CognitoGroupList',
  setup(__props) {

const store = useStore();

const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);
const groups = computed(() => store.getters['sysadmin/groups']);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!groups.value.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: group.groupname
              }, [
                _createElementVNode("td", null, _toDisplayString(group.GroupName), 1),
                _createElementVNode("td", null, _toDisplayString(group.Precedence), 1),
                _createElementVNode("td", null, _toDisplayString(group.Description), 1)
              ]))
            }), 128))
          ])
        ]))
  ]))
}
}

})